"use client";

import { useEffect, useState } from "react";

export function useIsIOS() {
    const [isIOS, setIsIOS] = useState(false);

    useEffect(() => {
        if (typeof window === "undefined") return;

        const userAgent = window.navigator.userAgent.toLowerCase();

        const isIOSDevice =
            /iphone|ipad|ipod/.test(userAgent) ||
            (window.navigator.platform === "MacIntel" &&
                window.navigator.maxTouchPoints > 1);

        const isStandalone =
            window.navigator.standalone === true ||
            window.matchMedia("(display-mode: standalone)").matches;

        setIsIOS(isIOSDevice && !isStandalone);
    }, []);

    return isIOS;
}
